/**
 * The empty choice of a package `Select` (« Tous », « Toutes », « Aucun »).
 *
 * The package `Select` is a Radix select, and Radix refuses an option whose value is the empty
 * string (it reserves `''` for « nothing selected », which shows the placeholder). Every filter of
 * this app carries its neutral choice as `''`, in its state and in its URL, so the empty string
 * crosses the component as this sentinel and only as this sentinel: `toSelectValue` on the way in,
 * `fromSelectValue` on the way out. Nothing outside a `Select` ever sees it.
 */
export const EMPTY_SELECT_VALUE = '__empty__';

/** The value a package `Select` is given for an app value (`''` becomes the sentinel). */
export function toSelectValue(value: string): string {
  return value === '' ? EMPTY_SELECT_VALUE : value;
}

/** The app value a package `Select` hands back (the sentinel becomes `''`). */
export function fromSelectValue(value: string): string {
  return value === EMPTY_SELECT_VALUE ? '' : value;
}
